// filepath: d:\Mes sites Web\animaux-de-la-seconde-chance\src\App.vue
<template>
  <div class="flex">
    <Sidebar @closeSidebar="closeSidebar" />

    <div class="flex-1 flex flex-col transition-all duration-300" :style="{ marginLeft: sidebarWidth }">
      <Header @toggleSidebar="toggleSidebar" />
      <router-view class="flex-1 overflow-auto" />

      <CookieCard :show="state.showBanner" @acceptAllCookies="acceptAllCookies" @managePreferences="managePreferences"
        @savePreferences="savePreferences" @closePreferences="closePreferences" />

      <Footer />

    </div>

  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import { useRecaptcha } from './composables/useRecaptcha';
import { isSidebarOpen, sidebarWidth, toggleSidebar, closeSidebar, openSidebar } from './store/storeSideBar.js';

import Header from './components/Header.vue';
import Sidebar from './components/Sidebar.vue';
import Footer from './components/Footer.vue';
import CookieCard from './components/CookieCard.vue';
import { useCookiePreferences } from './composables/useCookiePreferences.js';

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Footer,
    CookieCard,
  },
  setup() {
    // Gestion sidebar responsive
    const handleResize = () => {
      if (window.innerWidth <= 625) {
        closeSidebar();
      } else {
        openSidebar();
      }
    };

    // Utilisation du composable cookies
    const {
      state,
      acceptAllCookies,
      managePreferences,
      savePreferences,
      closePreferences
    } = useCookiePreferences();

    // Intégration reCAPTCHA
    const siteKey = '6LcWWiwrAAAAAAX71p6me0HWoPzX0zTxNaw_R9ml';
    const { loadRecaptcha, executeRecaptcha } = useRecaptcha(siteKey);

    onMounted(() => {
      window.addEventListener('resize', handleResize);
      handleResize();

      loadRecaptcha()
        .then(() => executeRecaptcha('homepage'))
        .then(token => {
          if (!token) {
            throw new Error('Le token reCAPTCHA est null ou vide');
          }
          console.log('Token reCAPTCHA:', token);
          // Envoi token backend si besoin
        })
        .catch(err => {
          console.error('Erreur lors du chargement/exécution reCAPTCHA :', err);
        });
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      isSidebarOpen,
      sidebarWidth,
      toggleSidebar,
      closeSidebar,

      state,
      acceptAllCookies,
      managePreferences,
      savePreferences,
      closePreferences,
    };
  }
};
</script>